import axios from "axios";
import { formBehaviourEnum } from "../components/commons/enum/formEnums";
import { stripRepeatFormPayload } from "../components/ui/forms/formRepeatUtils";
import { loginUserSuccessful } from "./login";

export const GET_FORM_MODEL = "GET_FORM_MODEL";
export const CLEAR_FORM = "CLEAR_FORM";
export const GET_FORM_DIAGNOSIS = "GET_FORM_DIAGNOSIS";
export const GET_FORM_DIAGNOSIS_NATURALEZA_ZONA = "GET_FORM_DIAGNOSIS_NATURALEZA_ZONA";
export const CLEAR_FORM_DIAGNOSIS_NATURALEZA_ZONA = "CLEAR_FORM_DIAGNOSIS_NATURALEZA_ZONA";
export const GET_FORM_NATURALEZAS_LESION = "GET_FORM_NATURALEZAS_LESION";
export const GET_FORM_ZONAS_AFECTADAS = "GET_FORM_ZONAS_AFECTADAS";
export const GET_FORM_PROFESSIONALS = "GET_FORM_PROFESSIONALS";
export const SET_FORM_PROFESSIONALS = "SET_FORM_PROFESSIONALS";
export const UPDATE_FORM_PROFESSIONALS = "UPDATE_FORM_PROFESSIONALS";
export const CLEAR_FORM_PROFESSIONALS = "CLEAR_FORM_PROFESSIONALS";
export const GET_FORM_PROFESSIONAL_SPECIALTIES = "GET_PROFESSIONAL_SPECIALTIES";
export const CLEAR_FORM_DIAGNOSIS = "CLEAR_FORM_DIAGNOSIS";
export const POST_FORM = "POST_FORM";
export const GET_FORM = "GET_FORM";
export const DOWNLOAD_ATTACHMENT = "DOWNLOAD_ATTACHMENT";
export const GET_ATTACHMENT_BASE64 = "GET_ATTACHMENT_BASE64";
export const GET_FORM_PRESTACIONES = "GET_FORM_PRESTACIONES";
export const GET_FORM_EMPLOYERS = "GET_FORM_EMPLOYERS";
export const GET_FORM_EMPLOYEE_OPTIONS = "GET_FORM_EMPLOYEE_OPTIONS";
export const GET_FORM_SPECIALTIES_DIAGNOSIS = "GET_FORM_SPECIALTIES_DIAGNOSIS";
export const POST_SIGN_FORM = "POST_SIGN_FORM";
export const CLEAR_IDTURNOS = "CLEAR_IDTURNOS";
export const SET_CHANGE_DOCUMENT = "SET_CHANGE_DOCUMENT";
export const SET_CHANGE_OPEN_DOCUMENT_DETAIL =
  "SET_CHANGE_OPEN_DOCUMENT_DETAIL";
export const GET_AFFECTED_ZONES = "GET_AFFECTED_ZONES";
export const CLEAR_AFFECTED_ZONES = "CLEAR_AFFECTED_ZONES";
export const GET_LOCALIDADES_PROVINCIA = "GET_LOCALIDADES_PROVINCIA";
export const CLEAR_FORM_LOCALIDADES = "CLEAR_FORM_LOCALIDADES";
export const NULLIFY_FORM = "NULLIFY_FORM";
export const GET_NULLIFY_REASONS = "GET_NULLIFY_REASONS";

export const GET_ENCRYPTED_FORM_URL = "GET_ENCRYPTED_FORM_URL";
export const GET_DECRYPTED_FORM = "GET_DECRYPTED_FORM";
export const GET_FORM_PERMISSIONS_BY_ROLE = "GET_FORM_PERMISSIONS_BY_ROLE";
export const EDIT_FORM_PERMISSIONS_FOR_ROLE = "EDIT_FORM_PERMISSIONS_FOR_ROLE";
export const ADD_FORM_PERMISSIONS_FOR_ROLE = "ADD_FORM_PERMISSIONS_FOR_ROLE";
export const DELETE_FORM_PERMISSIONS_FOR_ROLE = "DELETE_FORM_PERMISSIONS_FOR_ROLE";
export const GET_FORM_TYPES = "GET_FORM_TYPES";

export const nullifyForm = (values) => (dispatch) => {
  return dispatch({
    type: NULLIFY_FORM,
    payload: axios
      .post(`form/nullify`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getNullifyReasons = (idArt) => (dispatch) => {
  return dispatch({
    type: GET_NULLIFY_REASONS,
    payload: axios
      .get(`form/nullifyReasons?wriId=${idArt}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}

export const getFormModel = (type, idArt, idSiniestro) => (dispatch) => {
  return dispatch({
    type: GET_FORM_MODEL,
    payload: axios
      .get(`form/${type}/model?artId=${idArt}&siniestro=${idSiniestro}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const clearForm = () => ({
  type: CLEAR_FORM,
});

export const clearIdTurnosForms = () => ({
  type: CLEAR_IDTURNOS,
});

export const clearAffectedZones = () => ({
  type: CLEAR_AFFECTED_ZONES,
});

export const getFormNaturalezasLesion = (wriId) => (dispatch) => {
  return dispatch({
    type: GET_FORM_NATURALEZAS_LESION,
    payload: axios
      .get(`form/naturalezasLesion?wriId=${wriId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFormZonasAfectadas = (wriId) => (dispatch) => {
  return dispatch({
    type: GET_FORM_ZONAS_AFECTADAS,
    payload: axios
      .get(`form/zonasAfectadas?wriId=${wriId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getAffectedZones = (prestacionId) => (dispatch, getState) => {
  const { selectedProvider } = getState().providers;
  const { accident } = getState().accidentDashboard;

  return dispatch({
    type: GET_AFFECTED_ZONES,
    payload: axios
      .get(
        `form/affectedZones?prestacionId=${prestacionId}&providerId=${selectedProvider}&wriId=${accident.mlCloudCoreArtId}`,
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFormDiagnosis = (wriId) => (dispatch) => {
  dispatch({
    type: GET_FORM_DIAGNOSIS,
    payload: axios
      .get(`form/diagnosis?wriId=${wriId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFormDiagnosticoNaturalezaLesionZonaAfectada = (wriId, diagnosisId) => (dispatch) => {
  return dispatch({
    type: GET_FORM_DIAGNOSIS_NATURALEZA_ZONA,
    payload: axios
      .get(`form/diagnosticoNaturalezaLesionZonaAfectada?wriId=${wriId}&diagnosisId=${diagnosisId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}

export const clearFormDiagnosticoNaturalezaLesionZonaAfectada = () => (dispatch) => (
  dispatch({
    type: CLEAR_FORM_DIAGNOSIS_NATURALEZA_ZONA,
  })
)

export const getFormProfessionals = (wriId) => (dispatch) => {
  dispatch({
    type: GET_FORM_PROFESSIONALS,
    payload: axios
      .get(`form/professionals?wriId=${wriId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const setFormProfessionals = (newProfessional) => (dispatch) => {
  dispatch({
    type: SET_FORM_PROFESSIONALS,
    payload: newProfessional,
  });
};

export const updateFormProfessionals = (professional) => (dispatch) => {
  dispatch({
    type: UPDATE_FORM_PROFESSIONALS,
    payload: professional,
  });
};

export const getFormProfessionalSpecialties = (wriId) => (dispatch) => {
  dispatch({
    type: GET_FORM_PROFESSIONAL_SPECIALTIES,
    payload: axios
      .get(`form/professionalSpecialties?wriId=${wriId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postForm = (type, form, idArt) => (dispatch, getState) => {
  const { selectedProvider } = getState().providers;
  const { accident } = getState().accidentDashboard;
  const { behaviour } = getState().formsState;
  const payload =
    type === "fpt" && behaviour === formBehaviourEnum.REPEAT_FORM
      ? stripRepeatFormPayload(form)
      : form;
  if (idArt) {
    return dispatch({
      type: POST_FORM,
      payload: axios
        .post(
          `form/${type}?idArt=${idArt}&providerId=${selectedProvider}`,
          payload,
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  } else {
    return dispatch({
      type: POST_FORM,
      payload: axios
        .post(
          `form/${type}?idArt=${accident.mlCloudCoreArtId}&providerId=${selectedProvider}`,
          payload,
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  }
};

export const getForm =
  (type, wriId, siniestro, nroFormulario) => (dispatch) => {
    return dispatch({
      type: GET_FORM,
      payload: axios
        .get(
          `form/${type}?idArt=${wriId}&siniestro=${siniestro}&nroFormulario=${nroFormulario}`,
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  };

export const downloadAttachment =
  (nroFormulario, filename, idSiniestro, idArt) => (dispatch, getState) => {
    const { accident } = getState().accidentDashboard;

    return dispatch({
      type: DOWNLOAD_ATTACHMENT,
      payload: axios
        .get(
          `form/attachment/download?idArt=${idArt ? idArt : accident.mlCloudCoreArtId}&siniestro=${idSiniestro ? idSiniestro : accident.idSiniestro}&nroFormulario=${nroFormulario}&filename=${filename}`,
          {
            responseType: "blob",
          },
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  };

export const getAttachmentBase64 =
  (nroFormulario, filename, idSiniestro, idArt) => (dispatch, getState) => {
    const { accident } = getState().accidentDashboard;

    dispatch({
      type: GET_ATTACHMENT_BASE64,
      payload: axios
        .get(
          `form/attachment/base64?idArt=${idArt ? idArt : accident.mlCloudCoreArtId}&siniestro=${idSiniestro ? idSiniestro : accident.idSiniestro}&nroFormulario=${nroFormulario}&filename=${filename}`,
        )
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
    });
  };

export const getFormPrestaciones =
  (idART, isSupport, providerId) => (dispatch, getState) => {
    const { accident } = getState().accidentDashboard;
    const { selectedProvider } = getState().providers;

    if (idART) {
      dispatch({
        type: GET_FORM_PRESTACIONES,
        payload: axios
          .get(
            `form/prestaciones?wriId=${idART}&ProviderId=${providerId ?? selectedProvider}&isSupport=${isSupport ?? false}`,
          )
          .then((response) => ({ data: response.data }))
          .catch((error) => Promise.reject(error)),
      });
    } else {
      dispatch({
        type: GET_FORM_PRESTACIONES,
        payload: axios
          .get(
            `form/prestaciones?wriId=${accident.mlCloudCoreArtId}&ProviderId=${selectedProvider}`,
          )
          .then((response) => ({ data: response.data }))
          .catch((error) => Promise.reject(error)),
      });
    }
  };

export const getFormEmployers = (wriId) => (dispatch) => {
  return dispatch({
    type: GET_FORM_EMPLOYERS,
    payload: axios
      .get(`form/employers?wriId=${wriId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFormEmployeeOptions = (wriId, employerCuit) => (dispatch) => {
  return dispatch({
    type: GET_FORM_EMPLOYEE_OPTIONS,
    payload: axios
      .get(`form/employees?wriId=${wriId}&employerCuit=${employerCuit}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFormSpecialtiesDiagnosis = (wriId) => (dispatch) => {
  dispatch({
    type: GET_FORM_SPECIALTIES_DIAGNOSIS,
    payload: axios
      .get(`form/specialtiesDiagnosis?wriId=${wriId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postSignForm = (form) => (dispatch, getState) => {
  const { accident } = getState().accidentDashboard;

  return dispatch({
    type: POST_SIGN_FORM,
    payload: axios
      .post(`form/sign?idArt=${accident.mlCloudCoreArtId}`, form)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const setChangeDocument = (bool) => (dispatch) => {
  dispatch({
    type: SET_CHANGE_DOCUMENT,
    payload: bool,
  });
};

export const setOpenAccidentDocumentsDetail = (bool) => (dispatch) => {
  dispatch({
    type: SET_CHANGE_OPEN_DOCUMENT_DETAIL,
    payload: bool,
  });
};

export const getLocalidades =
  (idArt, provincia, isDesde, dondeKey) => (dispatch) => {
    const aux = dondeKey || (isDesde ? "desde" : "hasta");
    return dispatch({
      type: GET_LOCALIDADES_PROVINCIA,
      payload: axios
        .get(`form/localidades?idArt=${idArt}&provincia=${provincia}`)
        .then((response) => ({ data: response.data }))
        .catch((error) => Promise.reject(error)),
      // Variable de meta se usa para el fetch/caso de error para saber donde informacion
      meta: { donde: aux },
    });
  };

export const clearFormLocalidades = () => (dispatch) => {
  return dispatch({
    type: CLEAR_FORM_LOCALIDADES,
  });
};

export const getEncryptedFormUrl = ({ accidentId, wriId, providerId }) => (dispatch) => {
  return dispatch({
    type: GET_ENCRYPTED_FORM_URL,
    payload: axios
      .get(`form/newFormTempUrlParameters?accidentId=${accidentId}&wriId=${wriId}&providerId=${providerId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}

export const formDecryptUrl = (encryptedParameters) => (dispatch) => {
  return dispatch({
    type: GET_DECRYPTED_FORM,
    payload: axios.get(`form/decryptNewFormTempUrlParameters?encryptedParameters=${encryptedParameters}`)
      .then((response) => {
        const { auth, ...data } = response.data
        dispatch(loginUserSuccessful({ auth, email: data.mail }))
        return { ...data, encryptedParameters }
      })
      .catch((error) => Promise.reject(error)),
  });
}

export const getFormPermissionsByRole = (idArt) => (dispatch) => {
  return dispatch({
    type: GET_FORM_PERMISSIONS_BY_ROLE,
    payload: axios.get(`form/permissions/getByRole?wriId=${idArt}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}
/*
  IdArt
  IdRol
  PermisosFormularios: {
    idFormulario  
    ver: 
    crear:
    editar:
    borrar:  
  }
*/
export const addFormPermissionsForRole = (values) => (dispatch) => {
  return dispatch({
    type: ADD_FORM_PERMISSIONS_FOR_ROLE,
    payload: axios.post(`form/permissions/add`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}

export const editFormPermissionsForRole = (values, modificarTodosLosFormularios) => (dispatch) => {
  return dispatch({
    type: EDIT_FORM_PERMISSIONS_FOR_ROLE,
    payload: axios.post(`form/permissions/edit`, { ...values, modificarTodosLosFormularios })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}


export const deleteFormPermissionsForRole = (values) => (dispatch) => {
  return dispatch({
    type: DELETE_FORM_PERMISSIONS_FOR_ROLE,
    payload: axios.post(`form/permissions/delete`, values)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
}

export const getFormTypes = () => (dispatch) => {
  return dispatch({
    type: GET_FORM_TYPES,
    payload: axios.get(`form/formTypes`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  })
}